import React, { useState, useEffect } from "react"
import { Row, Col, Button, Form, FormGroup, Label, Input } from "reactstrap"
import { get, post } from "helpers/api_helper"
import { PAYROLL_SETTINGS_URL } from "helpers/url_helper"
import Notifications from "components/Notifications"

const AdvanceSalary = () => {
    const [limit, setLimit] = useState("50")
    const [isLoading, setIsLoading] = useState(false)
    const branch_id = "1"
    const brownBtnStyle = { backgroundColor: "#3d1e08", borderColor: "#3d1e08", color: "#fff" }

    const getData = async () => {
        setIsLoading(true)
        const res = await get(`${PAYROLL_SETTINGS_URL}?branch_id=${branch_id}`)
        if (res.status === 200 && res.response) {
            setLimit(res.response.advance_salary_limit)
        }
        setIsLoading(false)
    }

    useEffect(() => {
        getData()
    }, [])

    const handleSubmit = async (e) => {
        e.preventDefault()
        const res = await post(PAYROLL_SETTINGS_URL, { branch_id, advance_salary_limit: limit })
        if (res.status) {
            Notifications("success", res.message)
        } else {
            Notifications("error", res.message)
        }
    }

    return (
        <React.Fragment>
            <div className="mb-3">
                <h5 className="mb-0" style={{ fontWeight: "600", color: "#495057" }}>Advance Salary Settings</h5>
            </div>
            <Form onSubmit={handleSubmit}>
                <Row className="align-items-end">
                    <Col md={8}>
                        <FormGroup className="mb-0">
                            <Label>Advance Salary Limit(%) <span className="text-danger">*</span></Label>
                            <Input 
                                type="number" 
                                value={limit} 
                                onChange={(e) => setLimit(e.target.value)}
                                required 
                            />
                        </FormGroup>
                    </Col>
                    <Col md={4}>
                        <Button style={brownBtnStyle} className="w-100" type="submit" disabled={isLoading}>
                            <i className="fas fa-save me-1"></i> Update
                        </Button>
                    </Col>
                </Row>
            </Form>
        </React.Fragment>
    )
}

export default AdvanceSalary
